<template>
  <div class="share-pc">
    <div class="header">
      <div class="head-logo" />
    </div>
    <div class="main clearfix">
      <div class="main-left">
        <h1 style="margin: 20px 0; font-family: Georgia, 'Microsoft Yahei';">PwC You Plus<br>金句分享</h1>
        <p style="margin-bottom: 1.5rem; color: #999; line-height: 180%;">1.选择今日金句<br>2.点击“生成海报图片”按钮生成海报图片<br>3.将下载的海报分享至社交媒体。</p>
        <img :src="illuImg" width="360">
      </div>
      <div class="mobile">
        <yp-share :is-web="true" />
      </div>
    </div>
    <div class="footer">
      由于非Chrome浏览器兼容性不友好，建议拷贝地址栏完整URL使用Chrome浏览器进行操作，谢谢。
    </div>
  </div>
</template>
<script>
import { Notify } from 'vant'
import ypShare from './../mobile/index'
import illuImg from '@/assets/PwC_Repre_Illus_Iso_05_Chatbot_RGB.png'

var isChrome = window.navigator.userAgent.indexOf('Chrome')
if (isChrome !== -1) {
  console.log('is chrome')
} else {
  Notify({
    type: 'warning',
    message: '为了您能顺利完成生成海报图片，建议使用Chrome浏览器，谢谢。'
  })
}

export default {
  name: 'SharePc',
  components: {
    ypShare
  },
  data() {
    return {
      illuImg
    }
  }
}
</script>
<style>
html {
  font-size: 50px !important;
}
.share-pc {
  position: relative;
  width: 1200px;
  height: 100vh;
  margin: 0 auto;
}
.share-pc .header {
  margin-bottom: 20px;
  padding: 30px 0 20px;
  border-bottom: 1px solid #ddd;
}
.share-pc .head-logo {
  width: 300px;
  height: 60px;
  background: url(./../../../assets/logo.png) no-repeat;
  background-size: contain;
}
.share-pc .main {
  overflow: auto;
  height: auto;
  padding: 0 50px;
}
.share-pc .main-left {
  float: left;
  margin-top: 0.5rem;
  font-size: 0.28rem;
}
.share-pc .main .mobile {
  float: right;
  width: 360px;
}
.share-pc .footer {
  color: #777;
  font-size: 12px;
  text-align: center;
  border-top: 1px solid #ddd;
  padding: 10px;
  margin-top: 20px;
}
</style>
